import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import {INewYearRolloverSteps,INewYearRollOverRequest,INewYearRollOverResponse } from './new-year-rollover-steps';
import { HttpHelper } from '../../../shared/http-helper';

import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

@Injectable()
export class NewYearRolloverStepsService {
    
    private _newYearRolloverUrl = `api/systemmanagement`;
 
    constructor(private _httpHelper: HttpHelper) { }

   /* getNewYearRolloverStep(): Observable<INewYearRolloverSteps> {
         return this._httpHelper.get(`${this._newYearRolloverUrl}`)
    }*/

    public setManagerLockService(newYearRollOverRequest: INewYearRollOverRequest):Observable<INewYearRollOverResponse> {
         return this._httpHelper.post(`${this._newYearRolloverUrl}/SetManagerLock`, newYearRollOverRequest)
    }
    public newYearRollOverRunSteps(newYearRollOverRequest: INewYearRollOverRequest):Observable<INewYearRollOverResponse> {
         return this._httpHelper.post(`${this._newYearRolloverUrl}/NewYearRollOverRunSteps`, newYearRollOverRequest)
    }

    private handleError(error: Response) {
         // in a real world app, we may send the server to some remote logging infrastructure
         // instead of just logging it to the console
                 
         console.error(error);
         return Observable.throw(error.json().error || 'Server error');
    }
}


/** WEBPACK FOOTER **
 ** ./app/system-management/new-year-rollover/new-year-rollover-steps/new-year-rollover-steps.service.ts
 **/